// @flow

import { observer } from "mobx-react";
import React from "react";

import AppearanceStore from "app/stores/AppearanceStore";
import TimelineItemStore from "app/stores/TimelineItemStore";
import VideoStore from "app/stores/VideoStore";
import VideoPlayerStore from "app/stores/VideoPlayerStore";

import Timeline from "app/components/Timeline/Timeline";

@observer
export default class TimelineContainer extends React.Component<*> {
    render() {
        if (!VideoStore.isEditable && AppearanceStore.hiddenThumbnails)
            return null;

        return (
            <Timeline
                video={VideoStore.video}
                editable={VideoStore.isEditable}
                progress={VideoPlayerStore.progress}
                items={TimelineItemStore.orderedItems}
                selectedItem={TimelineItemStore.selectedItem}
                onSelect={TimelineItemStore.selectdByUser}
                onDeselect={TimelineItemStore.deselect}
                onMouseEnter={TimelineItemStore.mouseEnter}
                onDrag={TimelineItemStore.drag}
                onRequestCreate={TimelineItemStore.requestCreate}
                wizard={TimelineItemStore.wizard}
                canAdd={TimelineItemStore.canAdd}
                scale={AppearanceStore.scale}
                isMobile={AppearanceStore.isMobile}
                freezeScale={true}

                canGoBackward={TimelineItemStore.canSeekToPreviousItem}
                canGoForward={TimelineItemStore.canSeekToNextItem}
                onForward={TimelineItemStore.seekNext}
                onBackward={TimelineItemStore.seekPrevious}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/containers/TimelineContainer.js